var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgLocation16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81895 1.72795C7.84317 0.760277 6.54585 0.227295 5.16599 0.227295C3.78612 0.227295 2.48874 0.760309 1.51303 1.72795C0.537378 2.69584 0 3.98245 0 5.35103C0 6.33779 0.263628 7.5092 0.783797 8.83309C1.19529 9.8806 1.76818 11.028 2.4864 12.2437C3.70639 14.308 4.94414 15.8803 4.95631 15.8961C5.00691 15.9599 5.08413 15.9973 5.16592 15.9973C5.24771 15.9973 5.32493 15.9599 5.37553 15.8961C5.38783 15.8803 6.62545 14.308 7.84544 12.2437C8.56366 11.028 9.13655 9.8806 9.54804 8.83309C10.0684 7.50926 10.3321 6.33785 10.3321 5.35103C10.3321 3.98242 9.79466 2.69581 8.81904 1.72795H8.81895ZM5.16599 3.4618C6.2162 3.4618 7.07086 4.30947 7.07086 5.35109C7.07086 6.39294 6.2162 7.24039 5.16599 7.24039C4.11577 7.24039 3.26111 6.39297 3.26111 5.35109C3.26111 4.30947 4.11577 3.4618 5.16599 3.4618Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocation16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;